export default __webpack_public_path__ + "static/media/logo-sm.8a94e97b.svg";